<template>
  <div
    v-if="selectedUsersCount > 0"
    class="tw-pt-4 tw-my-2 tw-flex tw-items-center"
  >
    <SfToggle
      :disabled="toggleDisabled"
      :model-value="allowChanges"
      @click="toggleAllowChanges"
    ></SfToggle>
    <div class="tw-ml-2">
      {{ I18n.t('pulse.sharing.allow_proposing_changes') }}
    </div>
    <i
      v-tooltip="I18n.t('pulse.sharing.changes_tooltip')"
      class="
        fa fa-info-circle
        tw-pt-0.5 tw-text-lg tw-text-sf-dark-dark tw-ml-1
      "
    />
  </div>
  <div
    v-if="selectedUsersCount > 0 && toggleDisabled"
    class="tw-text-sf-gray-light tw-text-xs"
  >
    {{ I18n.t('pulse.sharing.changes_blocked') }}
    <br />
    <i class="fa fa-edit" />
    {{
      I18n.t('pulse.sharing.changes_blocked_templates', {
        n: activeProposals.length,
      })
    }}
  </div>
  <div v-if="showTextarea" class="tw-pt-4 tw-my-2">
    <div class="sf-below-1">
      <div class="sf-below-1 tw-font-medium">
        {{ I18n.t('pulse.sharing.optional_message') }}
      </div>
      <SfInput
        v-model="message"
        component-type="textarea"
        rows="3"
        :placeholder="I18n.t('pulse.sharing.add_message_for_pulse_users')"
        @update:model-value="updateMessage"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Proposal } from '../../shared/types/pulse-share'
import { ref, computed } from 'vue'
import SfToggle from '@app/shared/vue/components/sf-toggle.vue'
import SfInput from '@app/shared/vue/components/sf-input/sf-input.vue'

const I18n = window.I18n

interface Props {
  ledgerId: number
  sharedObjectId: number
  selectedUsersCount: number
  activeProposals: Proposal[]
  allowChanges: boolean
  showTextarea: boolean
}
const props = withDefaults(defineProps<Props>(), {
  activeProposals: () => [],
  allowChanges: true,
  showTextarea: false,
})

const allowChanges = ref(props.allowChanges)
const message = ref('')

const toggleDisabled = computed(() => {
  return props.activeProposals.length > 0
})

const emit =
  defineEmits<{
    toggleAllowChanges: [value: boolean]
    updateMessage: [value: string | undefined]
  }>()

function toggleAllowChanges(): void {
  allowChanges.value = !allowChanges.value
  emit('toggleAllowChanges', allowChanges.value)
}

function updateMessage(value: string | undefined): void {
  emit('updateMessage', value)
}
</script>
